import React, { useState } from 'react';
import { Button, Modal, TextField } from '@cimpress/react-components';
import { getTextureIdentity } from 'src/services/sceneClient';

import TextureButton from './textureButtonContainer';

interface TextureProps {
    id: string;
    width?: number;
    height?: number;
}

const Texture: React.FC<TextureProps> = ({ id, width: initialWidth, height: initialHeight }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [width, setWidth] = useState(initialWidth);
    const [height, setHeight] = useState(initialHeight);

    const toggleModal = () => {
        setIsOpen((prev) => !prev);
    };

    const download = () => {
        if (width == null || height == null || !Number.isFinite(width) || !Number.isFinite(height)) return;

        getTextureIdentity({ width, height }).then((identityImage) => {
            const dataUrl = URL.createObjectURL(identityImage);

            const tempIdentityElement = document.createElement('a');
            tempIdentityElement.href = dataUrl;
            tempIdentityElement.download = `textureIdentity_${width}x${height}`;
            document.body.appendChild(tempIdentityElement);
            tempIdentityElement.click();
            document.body.removeChild(tempIdentityElement);
            toggleModal();
        });
    };

    return (
        <div>
            <Button className='texture-scene-download-identity' style={{ marginBottom: '10px' }} onClick={toggleModal}>
                Generate Identity Texture
            </Button>
            <TextureButton id={id} />
            <Modal className='texture-scene-modal' show={isOpen} title='Generate Identity Texture' closeButton={true}>
                <div className='texture-scene-modal__body'>
                    <TextField
                        data-testid='texture_modal_width'
                        value={width}
                        onChange={(e) => setWidth(e.target.valueAsNumber)}
                        label='Width'
                        type='text'
                    />
                    <TextField
                        data-testid='texture_modal_height'
                        value={height}
                        onChange={(e) => setHeight(e.target.valueAsNumber)}
                        label='Height'
                        type='text'
                    />
                </div>
                <div className='texture-scene-modal__footer'>
                    <Button className='texture-scene-modal__footer-cancel' onClick={toggleModal}>
                        Cancel
                    </Button>
                    <Button className='texture-scene-modal__footer-download' variant='primary' onClick={download}>
                        Download
                    </Button>
                </div>
            </Modal>
        </div>
    );
};

export default Texture;
